import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';
import * as micropython from './micropython';
import * as tios from './tios';
import * as zephyr from './zephyr';
import * as simulator from './simulator';

export default class TimerStopNode extends BaseNode {
    constructor() {
        super();
        this.name = 'Timer Stop';
        this.id = 'node_timer_stop';
        this.icon = 'IoIosTimer';
        this.linkedFeature = 'general';

        this.inputs = [
            {
                name: 'Stop',
                portId: 'timer_stop',
                params: [],
            },
        ];

        const settings: Setting[] = [
            {
                id: 'TIMER',
                name: 'Timer',
                settingType: SettingType.OPTION,
                refId: 'timer',
                required: true,
                default: '',
                options: [],
            },
        ];

        this.settings = this.settings.concat(settings);
    }

    getSettingValue(settingId: string): string {
        if (settingId === 'DISPLAY_NAME') {
            const project: ProjectConfiguration = this.project;
            const value = super.getSettingValue(settingId);
            if (value !== '') {
                return value;
            }
            const TIMER = project.getFeature(this.getSettingValue('TIMER'));
            if (TIMER) {
                return `TIMER {{$${TIMER.getSettingValue('TIMER_NAME')}}} stop`;
            }
        }
        return super.getSettingValue(settingId);
    }

    getName(): string {
        const project: ProjectConfiguration = this.project;
        const TIMER = project.getFeature(this.getSettingValue('TIMER'));
        if (TIMER) {
            return `TIMER {{$${TIMER.getSettingValue('TIMER_NAME')}}} stop`;
        }
        return this.name;
    }

    getCodeBlocks(): CodeBlock[] {
        switch (this.project.runtime) {
            case 'micropython':
                return micropython.getCodeBlocks(this);
            case 'zephyr':
                return zephyr.getCodeBlocks(this);
            case 'simulator':
                return simulator.getCodeBlocks(this);
            default:
                return tios.getCodeBlocks(this);
        }
    }


    getDetails(): string {
        return `##### Timer Stop
This block stops the specified timer.

Note: This prevents the **On Timer** block from firing for the specified event (as it will never complete).`;
    }
}
